var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureExicess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0156 29.2383L16.0156 20.2383H38.0156L41.0156 29.2383M38.0156 39.2383C36.4156 39.2383 35.0156 37.8383 35.0156 36.2383C35.0156 34.6383 36.4156 33.2383 38.0156 33.2383C39.6156 33.2383 41.0156 34.6383 41.0156 36.2383C41.0156 37.8383 39.6156 39.2383 38.0156 39.2383ZM16.0156 39.2383C14.4156 39.2383 13.0156 37.8383 13.0156 36.2383C13.0156 34.6383 14.4156 33.2383 16.0156 33.2383C17.6156 33.2383 19.0156 34.6383 19.0156 36.2383C19.0156 37.8383 17.6156 39.2383 16.0156 39.2383ZM40.8156 19.2383C40.4156 18.0383 39.2156 17.2383 38.0156 17.2383H16.0156C14.6156 17.2383 13.6156 18.0383 13.2156 19.2383L9.01562 31.2383V47.2383C9.01562 48.4383 9.81562 49.2383 11.0156 49.2383H13.0156C14.2156 49.2383 15.0156 48.4383 15.0156 47.2383V45.2383H39.0156V47.2383C39.0156 48.4383 39.8156 49.2383 41.0156 49.2383H43.0156C44.2156 49.2383 45.0156 48.4383 45.0156 47.2383V31.2383M19.0156 5.23828L27.0156 14.2383L35.0156 5.23828H19.0156Z",
    fill: "#8F4300",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78906 50.9688L50.7278 3.02999",
    stroke: "#8F4300",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureExicess);
export default __webpack_public_path__ + "static/media/Feature_Exicess.9bd5d305efae93531985a883b309f939.svg";
export { ForwardRef as ReactComponent };